
function Hero() {

    return (
      <div className="text-center md:py-[96px] sm:py-[64px]">
        <h2 className="text-[16px] font-[600] text-[#7F56D9] mb-[12px] md:leading-[24px] sm:leading-[20px]">About us</h2>
        <h1 className="text-[36px] font-[700] text-[#101828] sm:px-[16px] md:leading-[60px] sm:leading-[44px]">We're built for software teams</h1>
        <p className="text-[20px] font-[400] text-[#667085] md:mt-[24px] sm:mt-[16px] md:leading-[30px] sm:leading-[28px] md:px-[336px] sm:px-[16px]">
            Our mission is to ensure teams can do their best work, no matter their size or budget. We focus on the details of everything we do.
        </p>
      </div>
    );
  }
  
  export default Hero;